import styled$1, { css } from 'styled-components';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';

const StyledRevealTypography = styled$1.span`
  display: block;
  position: relative;
  height: 100%;

  ${props => props.variant === 'primary' && css(["transform:translateX(", ");opacity:", ";transition:all 0.4s 0.4s ease-in-out;"], props.isVisible ? '0' : '50px', props.isVisible ? 1 : 0)}

  ${props => props.variant === 'secondary' && css(["&:after{position:absolute;top:0;right:0;background:linear-gradient(90deg,rgba(255,255,255,0.001) 0%,white 10%);width:100%;content:'';transform:", ";height:100%;transform-origin:right center;transition:all 0.4s 0.6s ease-in-out;}"], props.isVisible ? 'scaleX(0) scaleY(1.1)' : 'scaleX(1.2) scaleY(1.1)')}
`;

const RevealTypography = ({
  children,
  isVisible,
  variant
}) => {
  return /*#__PURE__*/React$1.createElement(StyledRevealTypography, {
    isVisible: isVisible,
    variant: variant
  }, children);
};

RevealTypography.propTypes = {
  children: PropTypes$1.node,
  variant: PropTypes$1.oneOf(['primary', 'secondary']),
  isVisible: PropTypes$1.bool
};
RevealTypography.defaultProps = {
  children: null,
  variant: 'primary',
  isVisible: false
};

export default RevealTypography;
